import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import truckImage from "../static/images/image1.png";
import logo from "../../logos/storage-sprint.png";
import { BiSolidHide, BiSolidShow } from "react-icons/bi";
import { Helmet } from 'react-helmet';
import { registerUser } from "../../Services/ApiCallsServices/AuthenticationApi";

const RegistrationPagePersonal = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [passwordError, setPasswordError] = useState("");
  const [logoLoaded, setLogoLoaded] = useState(false);

  const navigate = useNavigate();

  const MIN_LENGTH = 8;
  const UPPERCASE_REGEX = /[A-Z]/;
  const DIGIT_REGEX = /\d/;

  const validatePassword = (password) => {
    const errors = [];

    if (password.length < MIN_LENGTH) {
      errors.push(`Password should be at least ${MIN_LENGTH} characters long.`);
    }
    if (!UPPERCASE_REGEX.test(password)) {
      errors.push("Password should include at least one uppercase letter.");
    }
    if (!DIGIT_REGEX.test(password)) {
      errors.push("Password should include at least one number.");
    }

    setPasswordError(errors.join(" "));
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    validatePassword(newPassword);
  };

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      setLoading(false);
      return;
    }

    const formData = {
      firstName,
      lastName,
      email,
      phoneNumber,
      password,
      confirm_password: confirmPassword,
    };

    try {
      await registerUser(formData);
      console.log("Success");
      navigate("/auth-verify", {state: {email, role:"user"}});

    } catch (error) {
      console.error("Error:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Customer Registration - Storage Sprint</title>
      </Helmet>

      <div className="min-h-screen flex flex-col md:flex-row bg-white">
        {/* Left Side */}
        <div className="flex-1 flex flex-col items-center justify-center bg-yellow-500 text-white p-8">
          <img
            className="w-32 h-auto mb-6"
            src={logo}
            alt="Storage Sprint Logo"
          />
          <img
            className="w-full max-w-md h-auto object-contain hidden md:block"
            src={truckImage}
            alt="Storage Sprint Truck"
          />
          <h2 className="text-2xl md:text-3xl font-bold mt-6 text-center">
            SCHEDULE YOUR DELIVERY NOW!
          </h2>
        </div>

        {/* Right Side */}
        <div className="flex-1 flex flex-col items-center justify-center p-8">
          <div className="w-full max-w-md bg-white p-6 rounded-xl shadow-lg">
            <div className="flex flex-col items-center text-center mb-6">
              
              <h2 className="text-xl md:text-2xl font-bold text-yellow-600">
                CUSTOMER REGISTRATION
              </h2>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="First Name"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
                required
              />
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="Last Name"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
                required
              />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
                required
              />
              <input
                type="tel"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="Phone Number"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
                required
              />
              {passwordError && (
                <p className="text-red-500 text-sm">{passwordError}</p>
              )}
              <input
                type="password"
                value={password}
                onChange={handlePasswordChange}
                placeholder="Password"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
                required
              />
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm Password"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
                  required
                />
                <span
                  className="absolute inset-y-0 right-3 flex items-center text-gray-500 cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <BiSolidHide /> : <BiSolidShow />}
                </span>
              </div>
              <button
                type="submit"
                disabled={passwordError}
                className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-2 px-4 rounded-lg transition duration-200"
              >
                Register
              </button>
            </form>

            {loading && <p className="text-gray-500 text-sm mt-4">Loading...</p>}
            {error && <p className="text-red-500 text-sm mt-4">{error}</p>}

            <p className="text-sm text-gray-600 mt-4 text-center">
              Already have an account?{" "}
              <span
                className="text-yellow-600 font-semibold cursor-pointer hover:underline"
                onClick={handleLoginClick}
              >
                Login
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegistrationPagePersonal;